import axios from 'axios';

// Create axios instance
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

// GLOBAL ERROR HANDLER
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API ERROR:', {
      url: error.config?.url,
      status: error.response?.status,
      message: error.response?.data || error.message,
    });
    return Promise.reject(error);
  }
);

export default api;
